import React, { Component } from 'react';
import { connect } from 'react-redux';

class DownLoad extends Component {

    constructor(props) {
        super(props);
    }
    render() {
        const style = {
            backgroundColor: this.props.selectedColor
        }
        return (
            <button
                className="btn btn-default"
                type="button"
                title="Cliquer sur une case du modèle pour sélectionner sa couleur."
                style={style}>
                <span className="badge">
                    <span className="glyphicon glyphicon-tint"></span>
                </span>
            </button>
        )
    }
}

const mapStateToProps = ({ selectedColor }) => {
  return { selectedColor };
}

export default connect(mapStateToProps)(DownLoad)
